<div *ngIf="loading$ | async" fxLayout="column" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
</div>

<div class="container" fxLayout="row" fxLayoutGap="20px" [style.display]="(loading$ | async) ? 'none' : 'flex'">

  <!--<div fxFlex="250px" fxLayout="column" class="sidebar mat-elevation-z4">
    </app-date-navigator>
    <--<div class="sidebar-header">
      <h3>Valid from</h3>
      <button mat-mini-fab color="primary" (click)="createNewRate()" matTooltip="Create new entry">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-nav-list>
      <mat-list-item *ngFor="let rate of allRates"
                     (click)="selectRate(rate)"
                     [class.selected]="rate === selectedRate">
        <mat-icon matListIcon>calendar_today</mat-icon>
        <h4 matLine>{{ rate.startUpDate | date:'dd.MM.yyyy' }}</h4>
        <p matLine *ngIf="isCurrent(rate)" class="current-badge">Current</p>
      </mat-list-item>
    </mat-nav-list> -->
  <div fxFlex fxLayout="column">

    <div *ngIf="selectedRate; else noSelection" fxLayout="column">

      <div class="detail-header" fxLayout="row" fxLayoutAlign="space-between center">

        <h2 class="date-trigger" (click)="picker.open()">
          Tariffs effective from
          <span class="date-highlight">
      {{ selectedRate.startUpDate | date:'mediumDate' }}
    </span>
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;">edit_calendar</mat-icon>
        </h2>

        <button mat-raised-button color="primary" (click)="openNewEntryPicker()" matTooltip="Pick a new date to create an entry">
          <mat-icon>add</mat-icon>
          New entry
        </button>

        <input matInput
               [matDatepicker]="picker"
               [(ngModel)]="pickerDate"
               (dateChange)="onDateChange($event.value)"
               style="display: none;">

        <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>

      </div>

      <mat-table class="mat-elevation-z8" [dataSource]="dataSource">

        <ng-container matColumnDef="label">
          <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row.label}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="value">
          <mat-header-cell *matHeaderCellDef>Feed-in Tariff</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div fxFlex class="input-container">
              <mat-form-field fxFlex appearance="outline">
                <input matInput type="number" step="any" [(ngModel)]="row.value">
                <button mat-icon-button matSuffix
                        *ngIf="dataSource.hasChanged(row)"
                        matTooltip="Reset" (click)="dataSource.resetRow(row)">
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row" fxLayoutAlign="end center">
            <button mat-icon-button color="warn"
                    matTooltip="Remove row"
                    (click)="removeRow(row)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      </mat-table>

      <div class="meta-footer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" style="padding: 15px 0; opacity: 0.7; font-size: 0.9em;">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">person</mat-icon>
          <span>Last modified by: <strong>{{ selectedRate.lastModifiedBy }}</strong></span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">access_time</mat-icon>
          <span>On: <strong>{{ selectedRate.lastModifiedDate | date:'medium' }}</strong></span>
        </div>
      </div>

      <div class="actions">
        <button mat-raised-button color="primary" (click)="submit()">Save</button>
        <button mat-button color="warn" (click)="deleteSelectedRate()">Delete entry</button>
      </div>

    </div>

    <ng-template #noSelection>
      <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <p>Please select a date from the list.</p>
      </div>
    </ng-template>

  </div>

</div>
